import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { updateCompany } from "../../../../actions/clients/company/company";
import CustomLabel from "../../../sub/CustomLabel";
import {
  Alert,
  Button,
  Container,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import TableToolbar from "../../../sub/bootstrap/TableToolbar";
import Icon from "../../../sub/Icon";
import Paginator from "../../../sub/Paginator";
import Util from "../../../../util/Util";
import CompanyDevicesModal from "./CompanyDevicesModal";
import ConfirmationModal from "../../../sub/modals/ConfirmationModal";

class CompanyDevices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      serialNumberFilter: "",
      typeFilter: "",
    };

    this.paginator = new Paginator(this);
  }

  areResultsFiltered = () => {
    return (
      !Util.emptyString(this.state.serialNumberFilter) ||
      !Util.emptyString(this.state.typeFilter)
    );
  };

  resetSearchFields() {
    this.setState({
      serialNumberFilter: "",
      typeFilter: "",
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openCompanyDeviceModal(company, device) {
    this.setState({
      modal: (
        <CompanyDevicesModal
          company={company}
          device={device}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          isOpen={true}
          context="danger"
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  deleteDevice(company, device) {
    const updatedDevices = company.devices.filter(
      (d) => d.serial_number !== device.serial_number,
    );

    const data = {
      ...company,
      devices: updatedDevices,
    };

    this.props.onCompanyEdit(
      data,
      () => null,
      (e) => console.log(e),
    );
  }

  render() {
    const company = this.props.company.find(
      (c) => c._id === this.props.companyId,
    );

    this.paginator.init(company.devices.length);
    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    var devicesNodes =
      company.devices &&
      company.devices.length > 0 &&
      company.devices.map((device) => {
        if (
          this.state.serialNumberFilter &&
          this.state.serialNumberFilter !== ""
        ) {
          if (
            device.serial_number
              .toUpperCase()
              .indexOf(this.state.serialNumberFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (this.state.typeFilter && this.state.typeFilter !== "") {
          if (device.type !== this.state.typeFilter) return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <tr key={device.serial_number}>
            <td className="align-middle">{device.serial_number}</td>
            <td className="align-middle">
              {
                <FormattedMessage
                  id={device.type === "desk" ? "Terminal" : "Tablet"}
                />
              }
            </td>
            <td className="align-middle text-center tdaction">
              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>{<FormattedMessage id="Edit" />}</Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"edit" + device.serial_number}
                  variant="outline-dark"
                  onClick={(e) => this.openCompanyDeviceModal(company, device)}
                >
                  <Icon icon="pen-to-square" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {<FormattedMessage id="Delete" />}
                  </Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"delete" + device.serial_number}
                  variant="outline-dark"
                  onClick={(e) =>
                    this.openConfModal(
                      <FormattedMessage id="Warning" />,
                      <FormattedMessage id="Device.Delete.Warning" />,
                      () => this.deleteDevice(company, device),
                    )
                  }
                  className="ml-2"
                >
                  <Icon icon="trash" />
                </Button>
              </OverlayTrigger>
            </td>
          </tr>
        );
      });

    let resetSearchButton = () => {
      let button = (
        <button className="btn btn-outline-secondary" disabled>
          <Icon icon="filter" />
        </button>
      );

      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <div>
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Remove.Filter" />}
                </Tooltip>
              )}
              placement="bottom"
            >
              <button
                id="searchFilterBtn"
                className="btn btn-warning"
                onClick={() => this.resetSearchFields()}
              >
                <Icon icon="filter" />
              </button>
            </OverlayTrigger>
          </div>
        );
      } else {
        return button;
      }
    };
    return (
      <Container fluid>
        <TableToolbar>
          <CustomLabel
            label={this.props.intl.formatMessage({
              id: "Serial.Number",
            })}
            htmlFor="search_serial_number"
            labelClassName="my-1 mr-2"
          />
          <input
            id="search_ser ial_number"
            className="form-control form-control-sm mr-sm-3"
            type="search"
            onChange={(e) => {
              this.setState({ serialNumberFilter: e.target.value });
            }}
            placeholder={this.props.intl.formatMessage({ id: "Serial.Number" })}
            disabled={disableFormInput}
            value={this.state.serialNumberFilter}
          />

          <select
            id="search_role"
            className="form-control form-control-sm mr-sm-3"
            onChange={(e) => {
              this.setState({
                typeFilter: e.target.value,
              });
            }}
            disabled={disableFormInput}
            value={this.state.typeFilter}
          >
            <option value="">
              {this.props.intl.formatMessage({ id: "All" })}
            </option>
            <option value="desk">
              {this.props.intl.formatMessage({ id: "Terminal" })}
            </option>
            <option value="tablet">
              {this.props.intl.formatMessage({ id: "Tablet" })}
            </option>
          </select>

          {resetSearchButton()}
          <Button
            variant="info"
            className="ml-auto"
            onClick={() => this.openCompanyDeviceModal(company)}
          >
            <FormattedMessage id="Device.Add" />
          </Button>
        </TableToolbar>

        {company.devices.length === 0 ? (
          <Alert variant="secondary">
            <FormattedMessage id="Empty.Device" />
          </Alert>
        ) : (
          <table className="table tablee4mad">
            <thead>
              <tr>
                <th scope="col">
                  <FormattedMessage id="Serial.Number" />
                </th>
                <th scope="col">
                  <FormattedMessage id="Type" />
                </th>
                <th scope="col" className="align-middle text-center tdaction">
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>
            <tbody>{devicesNodes}</tbody>
          </table>
        )}

        {this.paginator.render()}

        {this.state.modal}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCompanyEdit: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyDevices));
